import React from 'react';
import PropTypes from 'prop-types';

import Moment from 'moment';
import { extendMoment } from 'moment-range';

import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

const moment = extendMoment(Moment);

const styles = theme => ({
  row: {
    height: 34,
  },
  cell: {
    textAlign: 'center',
    fontSize: 12,
    fontWeight: '400',
    color: theme.palette.grey[700],
    border: 'none',
    background: 'none',
  },
});

const DatepickerHeader = ({ classes }) => (
  <TableHead>
    <TableRow className={classes.row}>
      {[0, 1, 2, 3, 4, 5, 6].map((day) => {
        const formattedDay = moment().weekday(day).format('dd');
        return (
          <TableCell
            key={formattedDay}
            className={classes.cell}
            padding="none"
          >
            {formattedDay.charAt(0)}
          </TableCell>
        );
      })}
    </TableRow>
  </TableHead>
);

DatepickerHeader.propTypes = {
  classes: PropTypes.shape({
    row: PropTypes.string.isRequired,
    cell: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(DatepickerHeader);



// WEBPACK FOOTER //
// ./src/components/fields/DatepickerField/DatepickerHeader.js